import PropTypes from '@root/vendor/prop-types';
import { Colors, styled } from '@root/core/src/utils/styles';

export const VinMarker = styled('div')`
  --vin-marker-color: ${(props) => props.color || Colors.rootOrange()};

  position: absolute;
  top: ${(props) => props.yPos}%;
  left: ${(props) => props.xPos}%;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1.5px solid var(--vin-marker-color);
  background-image: radial-gradient(
    circle at center,
    hsl(from var(--vin-marker-color) H S L / 0.5) 10%,
    hsl(from var(--vin-marker-color) H S L / 0.05) 100%
  );

  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 3.5px;
    border-radius: 1px;
    background-color: white;
    box-shadow: 0 0 8px 1px var(--vin-marker-color);
  }
`;

VinMarker.propTypes = {
  color: PropTypes.string,
  xPos: PropTypes.number.isRequired,
  yPos: PropTypes.number.isRequired,
};
